import { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Button } from '@upmc/ims.component-library';
import styles from '../../../ApplicationMaintenance.module.scss';
import MaterialIcon from '@material/react-material-icon';
import Section from '../../../components/NewApplication/Section';
import DistributionListSearch from './DistributionListSearch';
import ExtensionTypeSelect from '../../../components/ExtensionTypeSelect';
import Base from '../../../../Base/Base';
import { AppDistributionList } from '../../../../../Classes/ResponseModels/Apps';
import { CreateDistributionListConfiguration } from '../../../_api';
import ApiErrors from '../../../components/NewApplication/ApiErrors';
import AppDistributionListRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/AppDistributionListRequest';

const DistributionListMapping = ({
	appID,
	app,
	readOnly,
	currentUser,
	requirementNumber,
	reload,
}) => {
	const mappingLogicOptions = [
		{
			label: 'All Users',
			statement: `Generic_All_Users_Logic ${appID}, `,
			id: 1,
		},
		{
			label: 'If Extension Value Equals',
			statement: 'Generic_If_Extension_Value_Equals_Logic, ',
			id: 2,
		},
	];

	const [modalOpen, setModalOpen] = useState(false);
	const [selectedDistributionList, setSelectedDistributionList] =
		useState(null);
	const [mappingLogic, setMappingLogic] = useState(mappingLogicOptions[0]);
	const [apiErrors, setApiErrors] = useState([]);
	const [isSaving, setIsSaving] = useState(false);
	//state values for if Extension Value Equals logic component
	const [extensionTypeID, setExtensionTypeID] = useState(null);
	const [checkValue, setCheckValue] = useState(null);

	//useEffect to reset mappingLogic statement to include correct parameter values when mappingLogic option is 'If Extension Value Equals'
	useEffect(() => {
		if (mappingLogic?.id === 2) {
			setMappingLogic({
				...mappingLogic,
				statement: `Generic_If_Extension_Value_Equals_Logic ${extensionTypeID}, '${checkValue}', `,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [extensionTypeID, checkValue]);

	const handleDistributionListSelect = distributionList => {
		setSelectedDistributionList(distributionList);
	};

	const handleMappingLogicChange = e => {
		let logicOption = mappingLogicOptions.find(
			opt => opt.id === e.target.value
		);
		if (logicOption) {
			setMappingLogic(logicOption);
		}
	};

	const handleSave = () => {
		const request = new AppDistributionListRequest(app, currentUser);
		request.appDistributionList = new AppDistributionList();
		request.appDistributionList.distributionListName =
			selectedDistributionList.DisplayName;
		request.appDistributionList.sqlStatement = mappingLogic?.statement;
		request.appDistributionList.appID = appID;
		request.RequirementNumber = requirementNumber;

		CreateDistributionListConfiguration(request)
			.then(response => {
				if (response.App.Errors.length > 0) {
					setApiErrors(response.App.Errors);
				} else {
					reload();
				}
			})
			.then(() => {
				setIsSaving(false);
			});
	};

	const MappingLogicSelect = () => {
		return (
			<>
				<p>Select Mapping Logic</p>

				<Select
					labelId='Mapping_Logic_Select'
					id='Mapping_Logic_Select'
					value={mappingLogic?.id}
					label='MappingLogicType'
					onChange={handleMappingLogicChange}
					name='mappingLogic'
				>
					{mappingLogicOptions.map(option => {
						return (
							<MenuItem key={option.id} value={option.id}>
								{option.label}
							</MenuItem>
						);
					})}
				</Select>
			</>
		);
	};

	const ConditionalLogicComponent = () => {
		switch (mappingLogic?.id) {
			case 1:
				//All Users, requires no additional logic, appID parameter assigned in mappingLogicOptions definition
				break;
			case 2:
				return (
					<>
						<hr></hr>
						<h4>Set 'If Extension Value Equals' Parameters</h4>

						<ExtensionTypeSelect
							extensionTypes={app.extensions ?? []}
							handleChange={e => {
								setExtensionTypeID(e.target.value);
							}}
							extensionID={extensionTypeID ?? null}
						/>
						<br></br>
						<br></br>
						<p>
							Check Value (if request extension value equals this
							value, user will be added to distribution list)
						</p>

						<input
							type='text'
							value={checkValue}
							onChange={e => setCheckValue(e.target.value)}
						/>
					</>
				);

			default:
				break;
		}
	};

	return (
		<div>
			<div className={styles.controlsContainer}>
				<Button
					variant='outlined'
					id='DL_Mapping_Modal'
					onClick={() => setModalOpen(true)}
					startIcon={<MaterialIcon icon='add' />}
					disabled={readOnly}
				>
					Create Distribution List Configuration
				</Button>
			</div>
			<Modal
				open={modalOpen}
				onClose={() => {
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base title='Create Distribution List Configuration'>
						<div className={styles.controlsContainer}>
							<Button
								onClick={e => {
									setIsSaving(true);
									handleSave();
								}}
								startIcon={<MaterialIcon icon='save' />}
								className={styles.editButton}
								id='DLMapping_Save'
								disabled={readOnly || isSaving}
							>
								Save
							</Button>
						</div>
						<ApiErrors errors={apiErrors} />
						<Section label='Distribution List Configuration'>
							{selectedDistributionList === null ? (
								<DistributionListSearch
									handleSelect={handleDistributionListSelect}
								/>
							) : (
								<div className={styles.row}>
									<strong>
										Mapping:{' '}
										{selectedDistributionList.DisplayName}
									</strong>

									<Button
										onClick={() =>
											setSelectedDistributionList(null)
										}
										variant='outlined'
										sx={{ mx: '.5em' }}
									>
										Reset Selected AD Group
									</Button>
								</div>
							)}
							{/* {select logic component} */}
							<br></br>
							{selectedDistributionList ? (
								<MappingLogicSelect />
							) : null}
							{/* {render logic component} */}
							{selectedDistributionList
								? ConditionalLogicComponent()
								: null}
						</Section>
						<div className={styles.controlsContainer}>
							<Button
								onClick={e => {
									setIsSaving(true);
									handleSave();
								}}
								startIcon={<MaterialIcon icon='save' />}
								className={styles.editButton}
								id='DistributionListMapping_Save2'
								disabled={readOnly || isSaving}
							>
								Save
							</Button>
						</div>
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default DistributionListMapping;
